<template>
  <Wrap>
    <h1>Журнал Трипстера</h1>
    <div class="subtitle">Вдохновляем на путешествия</div>
  </Wrap>
</template>

<script lang="ts" setup>
  import Wrap from '@/shared/Wrap.vue';
</script>

<style lang="scss" scoped>
  h1 {
    margin-top: 48px;
    color: var(--alias-color-text-default);
    font-weight: 800;
    font-size: 80px;
    line-height: 88px;
    text-align: center;

    @include tablet {
      margin-top: 32px;
      font-size: 48px;
      line-height: 56px;
    }

    @include mobile {
      margin-top: 16px;
      font-size: 36px;
      line-height: 44px;
    }
  }

  .subtitle {
    margin-top: 16px;
    color: var(--alias-color-text-default);
    font-size: 17px;
    line-height: 24px;
    letter-spacing: 0;
    text-align: center;

    @include tablet {
      margin-top: 8px;
    }

    @include mobile {
      margin-top: 4px;
      font-size: 12px;
      line-height: 16px;
    }
  }
</style>
